import config from 'config';

export abstract class Constants {
  static readonly CONTAINER_NAME = config.BLOB_CONTAINER_NAME;

  static readonly CONNECTION_URL = config.BLOB_STORAGE_URL;
}
